import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" No files uploaded ")
const _hoisted_2 = { style: {"display":"flex"} }
const _hoisted_3 = { style: {"display":"flex"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_f7_block_footer = _resolveComponent("f7-block-footer")
  const _component_f7_icon = _resolveComponent("f7-icon")
  const _component_f7_link = _resolveComponent("f7-link")
  const _component_f7_list_item = _resolveComponent("f7-list-item")
  const _component_f7_preloader = _resolveComponent("f7-preloader")
  const _component_f7_progressbar = _resolveComponent("f7-progressbar")
  const _component_f7_list = _resolveComponent("f7-list")
  const _component_f7_button = _resolveComponent("f7-button")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.noFiles)
      ? (_openBlock(), _createBlock(_component_f7_block_footer, {
          key: 0,
          class: "text-align-center"
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_f7_list, {
      "no-hairlines": "",
      class: "no-margin-top"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cloudFiles, (file) => {
          return (_openBlock(), _createBlock(_component_f7_list_item, {
            key: file.name,
            title: file.name
          }, {
            media: _withCtx(() => [
              _createVNode(_component_f7_icon, {
                f7: "doc_fill",
                size: "32"
              })
            ]),
            after: _withCtx(() => [
              _createVNode("div", _hoisted_2, [
                _createVNode(_component_f7_link, {
                  icononly: "",
                  external: "",
                  href: false,
                  onClick: ($event: any) => (_ctx.viewFile(file.name)),
                  tooltip: "Download"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_f7_icon, { f7: "arrow_down_doc" })
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                (!_ctx.readonly)
                  ? (_openBlock(), _createBlock(_component_f7_link, {
                      key: 0,
                      style: {"padding-left":"20px"},
                      href: false,
                      "icon-only": "",
                      onClick: ($event: any) => (_ctx.deleteFile(file.name)),
                      tooltip: "Delete"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_f7_icon, {
                          f7: "trash",
                          color: "red"
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 2
          }, 1032, ["title"]))
        }), 128)),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.uploadTasks, (task) => {
          return (_openBlock(), _createBlock(_component_f7_list_item, {
            key: task.snapshot.ref.name,
            title: task.snapshot.ref.name
          }, {
            media: _withCtx(() => [
              _createVNode(_component_f7_preloader)
            ]),
            footer: _withCtx(() => [
              _createVNode(_component_f7_progressbar, {
                style: {"width":"300px"},
                progress: _ctx.uploadProgress[task.snapshot.ref.name] ?? 0
              }, null, 8, ["progress"])
            ]),
            default: _withCtx(() => [
              _createVNode("div", _hoisted_3, [
                _createVNode(_component_f7_link, {
                  icononly: "",
                  external: "",
                  href: false,
                  onClick: ($event: any) => (_ctx.cancelUpload(task)),
                  tooltip: "Cancel upload"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_f7_icon, { f7: "xmark" })
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]),
            _: 2
          }, 1032, ["title"]))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode("input", {
      style: {"display":"none"},
      type: "file",
      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.filesChange($event))),
      id: _ctx.inputID,
      multiple: "",
      accept: _ctx.accept
    }, null, 40, ["id", "accept"]),
    _createVNode("label", { for: _ctx.inputID }, [
      (!_ctx.readonly)
        ? (_openBlock(), _createBlock(_component_f7_button, {
            key: 0,
            outline: "",
            href: false,
            external: true,
            style: {"margin":"20px 0"},
            text: "Upload files"
          }))
        : _createCommentVNode("", true)
    ], 8, ["for"])
  ], 64))
}